import { HttpResponse } from '@capacitor/core'

type HttpResponseWithError = HttpResponse & { error: boolean }

// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/noticeerror/
const newrelicNoticeError = ({
  error = {},
  customAttributes = {},
}: {
  error: Record<string, unknown> | HttpResponseWithError | string
  customAttributes?: Record<string, unknown>
}) => {
  if (window?.NREUM && error) {
    window.NREUM.noticeError(error, customAttributes)
  }
}

if (window?.NREUM) {
  const tag = window?.applicationVersion?.tag
  window.NREUM?.addRelease('v' + tag, tag)

  const errorsToIgnore = ['ServiceWorker']
  window.NREUM?.setErrorHandler((error) =>
    errorsToIgnore.some((errorToIgnore) =>
      error?.message?.includes(errorToIgnore)
    )
  )
}

export { newrelicNoticeError }
